module.exports = __webpack_public_path__ + "static/media/report-agent-report.6934fa41.jpg";